import { useSamplesDustDensityBaseDataDeleteMutation } from "@/services/backend/samples/api/dust-density-base-data-api";
import {
  DustDensityBaseData,
  dustDensityBaseDataKey,
} from "@/services/backend/samples/types/sample-base-data";
import { DeleteSampleBaseDataDialog } from "@/services/backend/samples/components/delete-sample-base-data-dialog";

export function DeleteDustDensityBaseDataDialog({
  baseData,
  onDeleted,
}: {
  baseData: DustDensityBaseData;
  onDeleted?: () => void;
}) {
  const mutation = useSamplesDustDensityBaseDataDeleteMutation();
  return (
    <DeleteSampleBaseDataDialog
      baseData={baseData}
      dataKey={dustDensityBaseDataKey}
      mutation={mutation}
      onDeleted={onDeleted}
    />
  );
}
